import { connect } from 'react-redux';
import Spinner from '../../components/Spinner';
import type { RootState } from '../../reducers';

const mapStateToProps = (state: RootState) => ({
  isVisible:
    !(state.initialization.success || state.initialization.error) ||
    state.currentApp.isLoading ||
    state.currentOverlay.isLoading,
});

export default connect(mapStateToProps)(Spinner);
